export const Z_INDEX = {
  negative: -1,
  low: 1,
  medium: 5,
  extraMedium: 10,
  backDrop: 15,
  high: 20,
};
